import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionRoomRequiredPrepMillisecond } from "./required-prep-milli-second";
import { QuestionSaleStartBeforeDate } from "./sale-start-before-date";
import { QuestionSalesTerm } from "./sale-term";
import { QuestionStayableDayOfTheWeek } from "./stayable-day-of-the-week";

import type { StandardOptionCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	salesTerm: StandardOptionCategoriesAndManagerStore["salesTerm"];
};

export const QuestionOptionSalesTerm = ({ salesTerm }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="期間の制限" categoryStore={salesTerm}>
				<QuestionSalesTerm />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="曜日の制限" categoryStore={salesTerm}>
				<QuestionStayableDayOfTheWeek />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="時間の制限" categoryStore={salesTerm}>
				<QuestionSaleStartBeforeDate />
				<QuestionRoomRequiredPrepMillisecond />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionOptionSalesTerm.displayName = "QuestionOptionSalesTerm";
